import { object, array, string } from '@gogame/schemas';

import {
  COLUMN_ID,
  COLUMN_NAME,
  COLUMN_STATUS,
  COLUMN_PARENT_CAMPAIGN,
  COLUMN_AFFILIATE,
  COLUMN_COST_MODELS_TYPES,
  COLUMN_COST_MODELS,
  COLUMN_APPLICATION,
  COLUMN_NETWORK,
  COLUMN_PLATFORM,
  COLUMN_COUNTRY,
  COLUMN_PROMO_CODE,
  COLUMN_ACTIVITY_TYPE,
  COLUMN_TYPE,
  COLUMN_FRAUD_PROTECTIONS,
  COLUMN_LABELS,
  COLUMN_CURRENT_OWNER,
  COLUMN_LAST_UPDATED,
  COLUMN_CREATED_BY,
  COLUMN_CREATED,
  COLUMN_CPE_EVENTS,
  COLUMN_LINK_TYPE,
  COLUMN_LINK_EXPIRATION_DATE,
  COLUMN_DEEP_LINK_REWARD_PACKAGE,
  COLUMN_DEEP_LINK_MULTIPLE_REDEMPTIONS,
  COLUMN_DEEP_LINK_MAX_REDEMPTIONS,
} from 'scenes/Campaigns/constants';

export const columnsSchema = object({
  order: array(string()).default([
    COLUMN_ID,
    COLUMN_NAME,
    COLUMN_STATUS,
    COLUMN_PARENT_CAMPAIGN,
    COLUMN_AFFILIATE,
    COLUMN_COST_MODELS_TYPES,
    COLUMN_CPE_EVENTS,
    COLUMN_COST_MODELS,
    COLUMN_APPLICATION,
    COLUMN_NETWORK,
    COLUMN_PLATFORM,
    COLUMN_COUNTRY,
    COLUMN_PROMO_CODE,
    // TODO remove after implemen type column
    COLUMN_ACTIVITY_TYPE,
    COLUMN_TYPE,
    COLUMN_FRAUD_PROTECTIONS,
    COLUMN_LABELS,
    COLUMN_CURRENT_OWNER,
    COLUMN_LINK_TYPE,
    COLUMN_LINK_EXPIRATION_DATE,
    COLUMN_DEEP_LINK_REWARD_PACKAGE,
    COLUMN_DEEP_LINK_MULTIPLE_REDEMPTIONS,
    COLUMN_DEEP_LINK_MAX_REDEMPTIONS,
    COLUMN_LAST_UPDATED,
    COLUMN_CREATED_BY,
    COLUMN_CREATED,
  ]),
  collapsed: array(string()).default([]),
});
